<template>
  <section style="display: flex; flex-direction: column;">
    <b-nav-text class="py-0 user-limit">{{ getUser.name }}</b-nav-text>
    <p class="py-0 version mb-0">2.2.1.6</p>
  </section>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "LoggedUser",
  computed: {
    ...mapGetters({
      getUser: "getUser"
    })
  }
};
</script>

<style scoped>
.version {
  font-size: 10px;
  text-align: end;
  color: rgba(255, 255, 255, 0.5);
}

@media only screen and (max-width: 770px) {
  .user-limit {
    display: none;
    max-width: 12ch;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/header/LoggedUser.vue